import React from "react";
import { OverviewScreenScreenWithBookingData } from "~/features/book-appointment/OverviewScreen";

const Component = () => {
  return <OverviewScreenScreenWithBookingData />;
};

export default Component;
